import { of } from "rxjs";
import { actionProductionNotEnoughResources, } from "../actionProductionInfo";
export var pathBuyMissingResources = function (action) {
    return of(actionProductionNotEnoughResources(action.amount, action.buildingId, action.recipeId, action.resourceIds));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/path/pathBuyMissingResources.ts
// module id = 1942
// module chunks = 3